import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Edit } from "lucide-react";
import { useState } from "react";
import { EditUserForm } from "./EditUserForm";
import { SchoolUser } from "@/types/users";
import { supabase } from "@/integrations/supabase/client";

interface EditUserDialogProps {
  userId: string;
  initialValues: SchoolUser & { 
    hasUnpaidBills?: boolean;
    hasActiveSubscription?: boolean;
  };
  onUserUpdated: () => void;
}

export const EditUserDialog = ({ userId, initialValues, onUserUpdated }: EditUserDialogProps) => {
  const [open, setOpen] = useState(false);
  const isSchoolIdLocked = initialValues.hasUnpaidBills || initialValues.hasActiveSubscription;

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="ghost" size="icon">
          <Edit className="h-4 w-4" />
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>Edit User</DialogTitle>
        </DialogHeader>
        <EditUserForm
          user={initialValues}
          isOpen={open}
          onClose={() => setOpen(false)}
          onSubmit={async (values) => {
            // If school ID is locked, ensure we use the original school_id
            const finalValues = isSchoolIdLocked
              ? { ...values, school_id: initialValues.school_id }
              : values;
            
            try {
              const { error } = await supabase
                .from('school_users')
                .update(finalValues)
                .eq('id', userId);

              if (error) throw error;

              onUserUpdated();
              setOpen(false);
            } catch (error) {
              console.error('Error updating user:', error);
            }
          }}
          isSchoolIdLocked={isSchoolIdLocked}
        />
      </DialogContent>
    </Dialog>
  );
};
